<template>
    <div class="toolbar-sort">
        <a :class="{active:null===field}" @click="eventClick(null)">
            <span>综合排序</span>
        </a>
        <a v-for="item in fields" :key="item.field" @click="eventClick(item.field)"
           :class="{active:item.field===field}">
            <span>{{ item.label }}</span>
            <div class="iconfont__outer" :class="sort">
                <i class="iconfont icon-sort-desc"/>
                <i class="iconfont icon-shengxuxu"/>
            </div>
        </a>
    </div>
</template>
<script>
export default {
    name: 'ToolbarSort',
    props: {
        fields: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            field: null,
            sort: 'desc'
        }
    },
    methods: {
        eventClick: function (field) {
            this.field = field
            this.sort = this.sort === 'desc' ? 'asc' : 'desc'
            this.$emit('change', this.field, this.sort)
        }
    }
}
</script>
<style lang="scss">
.toolbar-sort {
  display: inline-block;

  a {
    cursor: pointer;
    display: flex;
    align-items: center;
    float: left;
    color: #666;
  }

  a + a {
    margin-left: 20px;
  }

  a:hover {
    color: #777;
  }

  a.active {
    span {
      color: #fe346e;
    }

    .desc {
      .icon-sort-desc {
        color: #fe346e;
      }
    }

    .asc {
      .icon-shengxuxu {
        color: #fe346e;
      }
    }
  }

  .iconfont {
    font-size: 12px;
    position: absolute;

    &__outer {
      margin-left: 1px;
      position: relative;
      width: 16px;
      height: 16px;

      .icon-shengxuxu {
        right: 0;
      }
    }
  }

}
</style>